import { useEffect, useState } from "react";
import axiosRequest from '../../services/axios/axiosRequest';
import Header from "../../components/header/Header";
import Banner from "../../components/home/banner/Banner";
import Loading from '../../components/loading/Loading';
import BannerCard from '../../components/home/bannerCard/BannerCard';
import ProductsIntro from "../../components/home/productsIntro/ProductsIntro";
import ChemicalsIntro from "../../components/home/chemicalsIntro/ChemicalsIntro";
import OurServices from "../../components/home/ourServices/OurServices";
import MarqueeSlider from "../../components/home/marqueeSlider/MarqueeSlider";
import Footer from "../../components/footer/Footer";
import { Helmet } from "react-helmet-async";


export default function Home() {

  const [isLoading, setIsLoading] = useState(true);
  const [productsIntro, setProductsIntro] = useState([]);
  const [marqueeBrands, setMarqueeBrands] = useState([]);

  useEffect(() => {
    const productsIntroController = new AbortController();
    const brandsController = new AbortController();
    Promise.all([
      axiosRequest.get('/products/homepage/', { signal: productsIntroController.signal }),
      axiosRequest.get('/brands/', { signal: brandsController.signal }),
    ])
      .then(([productsRes, brandsRes]) => {
        setProductsIntro(productsRes.data);
        setMarqueeBrands(brandsRes.data);
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false));
    return () => {
      productsIntroController.abort();
      brandsController.abort();
    }
  }, []);


  return (
    <>
      <Header />

      <main className='min-vh-100'>
        {isLoading ? <Loading /> :
          <>
            <Banner />
            <BannerCard />
            <ProductsIntro data={productsIntro[0]} />
            <ChemicalsIntro data={productsIntro[1]} />
            <ProductsIntro data={productsIntro[2]} />
            <OurServices />
            <MarqueeSlider data={marqueeBrands} />
          </>
        }
      </main >

      <Footer />
    </>
  )
}
